export const OTHER_RECOMMENDATION_TYPE_ID = [
    12, // Transformer 
    27, // Generator
]
